import React from 'react';
// import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';

import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
// import PublishIcon from '@mui/icons-material/Publish';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
import GetAppIcon from '@mui/icons-material/GetApp';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import InfoOutlined from '@mui/icons-material/InfoOutlined';
// import Printicon from '@mui/icons-material/Print';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import {
// Box,
// Tab,
} from '@mui/material';
import {
// TabContext,
// TabList,
// TabPanel,
} from '@mui/lab';

import {
  FlexGridColumnGroup,
  // FlexGridCellTemplate
} from '@grapecity/wijmo.react.grid';

import {
// createTyohyoPdf,
// getCodeFromGeneralPurposeMap,
// changeDateFormat,
// getErrorCode,
// API_CODE,
// getErrorMessages,
// getResponseResult,
// getDataFromGeneralPurposeMap,
// getMaxDeleteNum
} from '../../../../common/common.js';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import {attachorderOperations} from '../../../../reducks/attachorder';
import MainContainer from '../../../organisms/MainContainer.js';
import {renderSelect} from '../../../atoms/CustomPart.js';
// import {createSearchList} from '../../../../../common/ComboParts.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
// import MuiTooltip from '../../../../atoms/MuiTooltip.js';
// import BackButton from '../../../atoms/Buttons/BackButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
// import KyogaCompanyInfo from '../../../../molecules/KyogaCompanyInformation.js';
// import * as validateRule from '../../../validateRule.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
// import {CellMaker} from '@grapecity/wijmo.grid.cellmaker';
// import {setSessionObject} from '../../../../common/Session.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import CustomAccordion from '../../../molecules/Accordion.js';
import {CellType} from '@grapecity/wijmo.grid';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.TSTK_ACTUAL_CONFIRM_LIST.name, href: ''},
];

const styles = (theme) => ({

});

// 一覧
const TsViews = [
  // {binding: 'tsTkGubun1', header: '区分', dataType: 'String', width: 130, readOnly: true},
  {binding: 'tsTkGubun2', header: '区分', dataType: 'String', width: 320, readOnly: true},

  {binding: 'tsGutisu', header: '調査数量(口)', dataType: 'Number', width: 130, readOnly: true},
];
// 一覧
const TkViews = [
  // {binding: 'tkTkGubun1', header: '区分', dataType: 'String', width: 130, readOnly: true},
  {binding: 'tkTkGubun2', header: '区分', dataType: 'String', width: 130, readOnly: true},
  {binding: 'tkTkGubun3', header: '区分', dataType: 'String', width: 130, readOnly: true},
  {binding: 'tkGutisu', header: '点検数量(口)', dataType: 'Number', width: 130, readOnly: true},
];

/**
 * 調査・点検実績確認画面
 * 画面ID:SCE1001
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonDisabled: true,
      buttonDisabled2: true,
      conditonList: [],
      warningMessages: [],
    };

    this.gridRef = React.createRef();
    this.gridRefTk = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);
      // FlexGridに初期値設定
      this.getInitializeData();
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
  }

  /**
   * 初期データ検索
   */
  getInitializeData = async () => {
    let initItems = {};
    // this.initializeItems(initItems);
    let dataTs = [];
    let dataTk = [];
    // let data = {};
    dataTs = [
      {tsTkGubun2: '定額電灯公衆街路灯のお客さま(4年1回の調査)', tsGutisu: ''},
      {tsTkGubun2: '上下以外のお客さま(毎年1回のお客さま含む)', tsGutisu: ''},
      {tsTkGubun2: '再調査', tsGutisu: ''},
      {tsTkGubun2: '小計', tsGutisu: ''},
    ];

    dataTk =[
      {tkTkGubun2: '点検箇所数', tkTkGubun3: '基本(同調)', tkGutisu: ''},
      {tkTkGubun2: '点検箇所数', tkTkGubun3: '基本(単独)', tkGutisu: ''},
      {tkTkGubun2: '点検数量', tkTkGubun3: '引込線', tkGutisu: ''},
      {tkTkGubun2: '点検数量', tkTkGubun3: '計器', tkGutisu: ''},
      {tkTkGubun2: '不良報告', tkTkGubun3: '引込線', tkGutisu: ''},
      {tkTkGubun2: '不良報告', tkTkGubun3: '計器', tkGutisu: ''},
      {tkTkGubun2: '不良報告', tkTkGubun3: '電柱番号相違', tkGutisu: ''},
      {tkTkGubun2: '小計', tkTkGubun3: '小計', tkGutisu: '', syokeiMerge: 'true'},

    ];

    // データを画面に設定
    this.props.doSetInitValues(initItems);

    this.gridRef.current.setItemsSource(dataTs);
    this.gridRefTk.current.setItemsSource(dataTk);

    this.setState({
      // henkoJohomaeList: henkoJohomaeList,
      // conditonList: conditonList,
    });
  };

  /**
   * 検索処理
   */
  _searchOrder = async () => {
    const dataTs =[
      {tsTkGubun2: '定額電灯公衆街路灯のお客さま(4年1回の調査)', tsGutisu: '1,000'},
      {tsTkGubun2: '上下以外のお客さま(毎年1回のお客さま含む)', tsGutisu: '3,000'},
      {tsTkGubun2: '再調査', tsGutisu: '100'},
      {tsTkGubun2: '小計', tsGutisu: '4,100'},

    ];

    const dataTk =[
      {tkTkGubun2: '点検箇所数', tkTkGubun3: '基本(同調)', tkGutisu: '1,000'},
      {tkTkGubun2: '点検箇所数', tkTkGubun3: '基本(単独)', tkGutisu: '2,000'},
      {tkTkGubun2: '点検数量', tkTkGubun3: '引込線', tkGutisu: '1,500'},
      {tkTkGubun2: '点検数量', tkTkGubun3: '計器', tkGutisu: '2,200'},
      {tkTkGubun2: '不良報告', tkTkGubun3: '引込線', tkGutisu: '10'},
      {tkTkGubun2: '不良報告', tkTkGubun3: '計器', tkGutisu: '20'},
      {tkTkGubun2: '不良報告', tkTkGubun3: '電柱番号相違', tkGutisu: '30'},
      {tkTkGubun2: '小計', tkTkGubun3: '小計', tkGutisu: '3,000', syokeiMerge: 'true'},

    ];

    this.gridRef.current.setItemsSource(dataTs);
    this.gridRefTk.current.setItemsSource(dataTk);

    return true;
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    this.setState({buttonDisabled2: true, warningMessages: []});
    const values = this.props.values;
    console.log(values);
    await this.props.reset();
    // const data =[];
    this.getInitializeData();
    return true;
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    this.setState({buttonDisabled2: false});
    this._searchOrder();
  };

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };


  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      // cssClass='bf-gray-background'
      isReadOnly={view.readOnly}/>;
  };

  /**
   * 項目フォーマット処理
   *
   * @param {object} s sender
   * @param {string} e event
   */
  formatItemFunction = (s, e) => {
    // 行が存在しない場合は終了
    const rows = s.rows;
    if (rows.length == 0) {
      return;
    }
    if (e.panel.cellType == CellType.Cell) {
      e.cell.style.backgroundColor = '';
      // ReadOnlyのセルか？
      // if (e.cell.ariaReadOnly) {
      //   e.cell.style.backgroundColor = '#e6e6fa';
      // }
    }
    if (e.panel.cellType == CellType.Cell) {
      const col = e.getColumn();
      const data = s.rows[e.row].dataItem;
      if (col && ((col.binding === 'sinnseiStatus' &&
        data.hiKetuFlag === '1') )) {
        // e.cell.style.backgroundColor = '#fff0f5';
        e.cell.style.backgroundColor = '#ff0000';
      }
    }
  };

  doConfirm = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['帳票出力'],
      },
    });
  };

  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'none',
      filterOn: false,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'None',
      AddDeleteOn: false,
      style: {maxHeight: '470px', maxWidth: 'auto', height: 'auto', width: 'auto'},
      isReadOnly: true,
      checkedFunction: this.checkStateUpdate,
      formatItemFunction: this.formatItemFunction,
      customMergedRange: this.mergedRange,
    };

    let viewElems = [];
    if (TsViews) {
      for (const view of TsViews) {
        const header = view.header;
        if (!header) {
          continue;
        }
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            let secondViewElem;
            let thirdViewGElem;
            // 2層ヘッダー処理
            if (elem.dataType === 'header') {
              let secondViewGroups = [];
              for (const secondElem of elem.elems) {
                if (secondElem.dataType === 'header') {
                  let thirdViewGroups = [];
                  for (const thirdElem of secondElem.elems) {
                    thirdViewGroups.push(this.getViewElem(thirdElem));
                  }
                  thirdViewGElem =
                    <FlexGridColumnGroup header={secondElem.header}>
                      {thirdViewGroups}
                    </FlexGridColumnGroup>;
                  secondViewGroups.push(thirdViewGElem);
                } else {
                  secondViewGroups.push(this.getViewElem(secondElem));
                }
              }
              secondViewElem = <FlexGridColumnGroup header={elem.header}>
                {secondViewGroups}
              </FlexGridColumnGroup>;
              viewGroups.push(secondViewElem);
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }
  /**
   * 一覧表示
   * @return {object}
   */
  renderTableTk() {
    const props = {
      rowHeaderType: 'none',
      filterOn: false,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'None',
      AddDeleteOn: false,
      style: {maxHeight: '470px', maxWidth: 'auto', height: 'auto', width: 'auto'},
      isReadOnly: true,
      checkedFunction: this.checkStateUpdate,
      formatItemFunction: this.formatItemFunction,
      customMergedRange: this.mergedRange,
    };

    let viewElems = [];
    if (TkViews) {
      for (const view of TkViews) {
        const header = view.header;
        if (!header) {
          continue;
        }
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            let secondViewElem;
            let thirdViewGElem;
            // 2層ヘッダー処理
            if (elem.dataType === 'header') {
              let secondViewGroups = [];
              for (const secondElem of elem.elems) {
                if (secondElem.dataType === 'header') {
                  let thirdViewGroups = [];
                  for (const thirdElem of secondElem.elems) {
                    thirdViewGroups.push(this.getViewElem(thirdElem));
                  }
                  thirdViewGElem =
                    <FlexGridColumnGroup header={secondElem.header}>
                      {thirdViewGroups}
                    </FlexGridColumnGroup>;
                  secondViewGroups.push(thirdViewGElem);
                } else {
                  secondViewGroups.push(this.getViewElem(secondElem));
                }
              }
              secondViewElem = <FlexGridColumnGroup header={elem.header}>
                {secondViewGroups}
              </FlexGridColumnGroup>;
              viewGroups.push(secondViewElem);
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      <CustomFlexGrid ref={this.gridRefTk} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="surveyYear" item xs={12} sm={1}>
            <Field
              id="surveyYear"
              name="surveyYear"
              component={renderSelect}
              className="fields"
              label="年度"
              type="text"
              fullWidth
              required={true}
              // validate={[
              //   validateRule.number,
              //   validateRule.maxLength(4),
              // ]}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'2026'}</MenuItem>
              <MenuItem value={2}>{'2025'}</MenuItem>
              <MenuItem value={3}>{'2024'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="surveyMonth" item xs={12} sm={1}>
            <Field
              id="surveyMonth"
              name="surveyMonth"

              component={renderSelect}
              className="fields"
              label="月度"
              type="text"
              fullWidth
              required={true}
              // validate={[
              //   validateRule.number,
              //   validateRule.maxLength(4),
              // ]}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'1月'}</MenuItem>
              <MenuItem value={2}>{'2月'}</MenuItem>
              <MenuItem value={3}>{'3月'}</MenuItem>
              <MenuItem value={4}>{'4月'}</MenuItem>
              <MenuItem value={5}>{'5月'}</MenuItem>
              <MenuItem value={6}>{'6月'}</MenuItem>
              <MenuItem value={7}>{'7月'}</MenuItem>
              <MenuItem value={8}>{'8月'}</MenuItem>
              <MenuItem value={9}>{'9月'}</MenuItem>
              <MenuItem value={10}>{'10月'}</MenuItem>
              <MenuItem value={11}>{'11月'}</MenuItem>
              <MenuItem value={12}>{'12月'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="zigyoujo" item xs={12} sm={2}>
            <Field
              id="zigyoujo"
              name="zigyoujo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="NW事業所"
              type="text"
              fullWidth
              required={true}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北'}</MenuItem>
              <MenuItem value={6120}>{'山口'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="zigyoujoOld" item xs={12} sm={2}>
            <Field
              id="zigyoujoOld"
              name="zigyoujoOld"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="旧NW事業所"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北'}</MenuItem>
              <MenuItem value={6120}>{'廿日市'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="itakuArea" item xs={12} sm={2}>
            <Field
              id="itakuArea"
              name="itakuArea"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="委託エリア"
              type="text"
              fullWidth
              required={true}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={0}>{'中電ＮＷ'}</MenuItem>
              <MenuItem value={1}>{'委託１'}</MenuItem>
              <MenuItem value={2}>{'委託２'}</MenuItem>
              <MenuItem value={3}>{'委託３'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="tyousakikan" item xs={12} sm={2}>
            <Field
              id="tyousakikan"
              name="tyousakikan"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査会社"
              type="text"
              fullWidth
              required={true}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={'0000'}>{'中電ＮＷ'}</MenuItem>
              <MenuItem value={3000}>{'保安協会'}</MenuItem>
              <MenuItem value={5000}>{'工業組合'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="tskkJgyosyo" item xs={12} sm={2}>
            <Field
              id="tskkJgyosyo"
              name="tskkJgyosyo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査機関事業所"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={4510}>{'福山支'}</MenuItem>
              <MenuItem value={4580}>{'府中支'}</MenuItem>

            </Field>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="tsTkUserId" item xs={12} sm={2}>
            <Field
              id="tsTkUserId"
              name="tsTkUserId"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="担当者"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={'TB0001'}>{'田中　一郎'}</MenuItem>
              <MenuItem value={'TB0002'}>{'田中　二郎'}</MenuItem>

            </Field>
          </Grid>
        </Grid>
        {/* <div style={{marginBottom: '15px'}} /> */}
      </React.Fragment>
    );
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    // const {
    //   handleSubmit,
    // } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        <Grid key="key1001CreateTen4" item>
          <PositiveButton
            id="btn1001CreateTen4"
            onClick={this.doConfirm}
            variant="contained"
            startIcon={<GetAppIcon />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>完了届兼請求書作成</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1001CreateTen4" item>
          <PositiveButton
            id="btn1001CreateTen4"
            onClick={this.doConfirm}
            variant="contained"
            startIcon={<GetAppIcon />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>屋内線定期調査および引込線・計器点検実施報告書作成</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1001CreateTen4" item>
          <PositiveButton
            id="btn1001CreateTen4"
            onClick={this.doConfirm}
            variant="contained"
            startIcon={<GetAppIcon />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>屋内線定期調査実施内訳書作成</span>
          </PositiveButton>
        </Grid>
      </Grid>
    );
  };

  /**
   * セル結合をカスタム
   * @param {object} wjgGrid wijmo.grid モジュール
   * @param {object} panel 範囲を含むGridPanel
   * @param {number} r セルが含まれる行のインデックス
   * @param {number} c セルが含まれる列のインデックス
   * @param {boolan} clip 結合範囲をグリッドの現在のビュー範囲にクリップするかどうか
   * @return {*} 結合範囲を指定するCellRange
   */
  mergedRange = (wjgGrid, panel, r, c, clip = true) => {
    let rng = new wjgGrid.CellRange(r, c);

    if (panel.cellType == CellType.ColumnHeader) {
      // if (r == 0) {
      //   rng.col = c - (c % 3);
      //   rng.col2 = rng.col + 2;
      //   return rng;
      // }
      // if (r == 0 && ['tsTkGubun1', 'tsTkGubun2'].includes(panel.columns.at(c).binding)) {
      //   rng.col = 0;
      //   rng.col2 = 1;
      //   return rng;
      // }
      if (r == 0 && ['tkTkGubun2', 'tkTkGubun3'].includes(panel.columns.at(c).binding)) {
        rng.col = 0;
        rng.col2 = 1;
        return rng;
      }
    }

    if (panel.cellType == CellType.Cell) {
      if (c < 2) {
        let pcol = c > 0 ? c - 1 : c;
        let pval = panel.getCellData(r, pcol, false);
        let val = panel.getCellData(r, c, false);

        // 縦結合（up）※現行と前行の列が一致
        while (rng.row > 0 &&
          panel.getCellData(rng.row - 1, c, false) == val &&
          panel.getCellData(rng.row - 1, pcol, false) == pval) {
          rng.row--;
        }
        // 縦結合（down）※現行と前行のが一致
        while (rng.row2 < panel.rows.length - 1 &&
          panel.getCellData(rng.row2 + 1, c, false) == val &&
          panel.getCellData(rng.row2 + 1, pcol, false) == pval) {
          rng.row2++;
        }
        // 横結合
        const data = panel.rows[r].dataItem;
        if (data.syokeiMerge) {
          rng.col = 0;
          rng.col2 = 1;
        }
      } else {

      }
    }
    return rng;
  };

  render() {
    const {classes,
      // generalPurposeMap,
      // reset,
      handleSubmit,
      // values,
      //  userInfo
    } = this.props;

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    // タブとタブパネルを生成
    // const tabElements = this._createTabElements();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          footerBtn={footerBtn}>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={transitionList}/>
          <Grid key="keySCA1001Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <PaperPart>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="search" item xs={12}>
                <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={true}/>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="right"
              alignItems="right"
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this._reset)}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '10px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '10px'}} />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-end"
          >

            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"

              direction={'row'}
            >
              <PaperPart style={{height: '410px', marginLeft: '0px'}}>
                <Typography variant='h6' sx={{fontWeight: 'bold'}}>定期調査</Typography>
                {this.renderTable()}
              </PaperPart>
              <div style={{marginLeft: '20px'}} />
              <PaperPart style={{height: '410px'}}>
                <Typography variant='h6' sx={{fontWeight: 'bold'}}>引込線点検</Typography>
                {this.renderTableTk()}
              </PaperPart>

            </Grid>

          </Grid>
        </MainContainer>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  orderList: PropTypes.array,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  order: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderTypeList: PropTypes.func,
  doSetOrderId: PropTypes.func,
  doDeleteProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetStbType: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doRetrieveOrder: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetOrderModifiedCondition: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
    initialValues: {
      surveyYear: '1',
      surveyMonth: '12',
      zigyoujo: '5160',
    },
    // initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);

